import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/home/home'
import Empresa from '@/components/empresas/empresas'
import Login from '@/components/login/auth'
import Cliente from '@/components/clientes/clientes'
import NovoCliente from '@/components/clientes/novoCliente'
import Configs from '@/components/configs/configs'
import Notificacoes from '@/components/configs/notificacoes'
import meFuncionarios from '@/components/configs/meFuncionarios'
import meClientes from '@/components/configs/meClientes'
import me from '@/components/configs/me'
import Senha from '@/components/configs/alteraSenha'
import NovoOrcamento from '@/components/orcamento/novoOrcamento'
import Cargas from '@/components/cargas/cargas'
import Caminhoes from '@/components/caminhoes/caminhoes'
import CargasPorCaminhao from '@/components/caminhoes/cargaPorCaminhao'
import Orcamentos from '@/components/orcamento/orcamentos'
import Rejeitados from '@/components/orcamento/rejeitados'
import Estornados from '@/components/orcamento/estornados'
import Aceitos from '@/components/orcamento/aceitos'
import AceitosCliente from '@/components/orcamento/aceitosCliente'
import OrcamentosCliente from '@/components/orcamento/orcamentosCliente'
import Baixados from '@/components/orcamento/baixados'
import Propostas from '@/components/orcamento/propostas'

Vue.use(VueRouter)

const routes = [{
  name: 'home',
  path: '/',
  component: Home
},{
  name: 'empresa',
  path: '/empresa',
  component: Empresa
},{
  name: 'login',
  path: '/login',
  component: Login
},{
  name: 'cliente',
  path: '/cliente',
  component: Cliente
},{
  name: 'novoCliente',
  path: '/novoCliente',
  component: NovoCliente
},{
  name: 'configs',
  path: '/configs',
  component: Configs
},{
  name: 'notificacoes',
  path: '/notificacoes',
  component: Notificacoes
},{
  name: 'meClientes',
  path: '/meClientes',
  component: meClientes
},{
  name: 'meFuncionarios',
  path: '/meFuncionarios',
  component: meFuncionarios
},{
  name: 'me',
  path: '/me',
  component: me
},{
  name: 'senha',
  path: '/senha',
  component: Senha
},{
  name: 'novoOrcamento',
  path: '/novoOrcamento',
  component: NovoOrcamento
},{
  name: 'cargas',
  path: '/cargas',
  component: Cargas
},{
  name: 'caminhoes',
  path: '/caminhoes',
  component: Caminhoes
},{
  name: 'cargasPorCaminhao',
  path: '/cargasPorCaminhao',
  component: CargasPorCaminhao
},{
  name: 'orcamentos',
  path: '/orcamentos',
  component: Orcamentos
},{
  name: 'rejeitados',
  path: '/rejeitados',
  component: Rejeitados
},{
  name: 'estornados',
  path: '/estornados',
  component: Estornados
},{
  name: 'baixados',
  path: '/baixados',
  component: Baixados
},{
  name: 'aceitos',
  path: '/aceitos',
  component: Aceitos
},{
  name: 'aceitosCliente',
  path: '/aceitosCliente',
  component: AceitosCliente
},{
  name: 'orcamentosCliente',
  path: '/orcamentosCliente',
  component: OrcamentosCliente
},{
  name: 'propostas',
  path: '/propostas',
  component: Propostas
}
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
